import { AdminActivityWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AdminActivityWebService.Configuration
});

export default config;
